import { useFetcher } from "react-router-dom";
import {
  SHELL_ACTION_FIELD,
  SHELL_ACTION_INTENT,
  SHELL_ACTION_PATH,
} from "@/constants/shellActions";

export const useShellActionFetcher = () => {
  const fetcher = useFetcher({ key: "shell-action" });

  const submitLogout = () => {
    void fetcher.submit(
      { [SHELL_ACTION_FIELD.INTENT]: SHELL_ACTION_INTENT.LOGOUT },
      { method: "post", action: SHELL_ACTION_PATH },
    );
  };

  const submitSwitchFinancialInstitution = (financialInstitution: string) => {
    void fetcher.submit(
      {
        [SHELL_ACTION_FIELD.INTENT]: SHELL_ACTION_INTENT.SWITCH_FI,
        [SHELL_ACTION_FIELD.FINANCIAL_INSTITUTION]: financialInstitution,
      },
      { method: "post", action: SHELL_ACTION_PATH },
    );
  };

  return {
    fetcher,
    submitLogout,
    submitSwitchFinancialInstitution,
    isShellActionPending: fetcher.state !== "idle",
  };
};
